import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Switch } from '@rsos/base-components';
import { useUpdatePreconfiguredMessageMutation } from '@rsos/reduxDataStore/src/features/preconfiguredMessages';
import type { PreconfiguredResponse } from '@rsos/reduxDataStore/src/features/preconfiguredMessages/preconfiguredMessagesAPI';
import { organizationSelector } from '@rsos/reduxDataStore/src/features/selectors/organizationSelector';
import { notifyError, notifySuccess } from '@rsos/utils/toastUtils';
import { AppState } from '../../../types';
import { UPDATE_SUCCESS_MESSAGE } from '../modals/utils';
import { trackToggleSuggestedResponse } from '../preconfiguredMessagesTrackings';
import { Row } from '../tableShared/index.styles';

interface Props {
  rsosMessage: PreconfiguredResponse;
}

const TableRow: FunctionComponent<Props> = ({ rsosMessage }) => {
  const orgName =
    useSelector((state: AppState) => organizationSelector(state))?.name || '';
  const [updatePreconfiguredMessage] = useUpdatePreconfiguredMessageMutation();

  const handleToggle = () => {
    const isMessageEnabled = rsosMessage.enabled;

    trackToggleSuggestedResponse(!isMessageEnabled, rsosMessage);

    updatePreconfiguredMessage({
      org: orgName,
      id: rsosMessage.id,
      updates: { enabled: !isMessageEnabled },
    })
      .unwrap()
      .then(() => {
        notifySuccess(UPDATE_SUCCESS_MESSAGE);
      })
      .catch((error: unknown) => {
        const err = error as { data?: { message?: string } };
        notifyError(err.data?.message || 'Failed to update message');
      });
  };
  return (
    <Row>
      <td>{rsosMessage.title ?? ''}</td>
      <td>{rsosMessage.body ?? ''}</td>
      <td>
        <Switch onOffLabel isOn={rsosMessage.enabled} onClick={handleToggle} />
      </td>
    </Row>
  );
};

export default TableRow;
